var map = {
	"./de.json": [
		9929,
		645
	],
	"./en.json": [
		790,
		551
	],
	"./fr.json": [
		844,
		221
	],
	"./it.json": [
		504,
		453
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2395;
module.exports = webpackAsyncContext;